import { NestedRoutes } from "../../../app/routes.types";
import { Companies } from ".";
import CompaniesIcon from "../../../assets/Admin/Companies";
import { AddCompanyForm } from "./AddCompany";
import { EditCompanyForm } from "./EditCompany";
import { Api } from "../../../services/api";
import { UserPermissions } from "../../../enums";

export const CompaniesRoutes: NestedRoutes = {
  icon: CompaniesIcon,
  name: "Companies",
  path: "companies",
  component: Companies,
  permissions: [UserPermissions.CompanyViewList],
  children: [
    {
      name: "Add Company",
      path: "add",
      component: AddCompanyForm,
    },
    {
      path: ":companyId",
      getName: async (params: Record<string, string>) => {
        return await Api.companies.getCompany(params.companyId).then(res => {
          return res.data.name;
        });
      },
      permissions: [
        UserPermissions.CompanyViewDetails,
        UserPermissions.CompanyManageDetails,
      ],
      children: [
        {
          name: "Edit",
          path: "edit",
          component: EditCompanyForm,
          permissions: [
            UserPermissions.CompanyViewDetails,
            UserPermissions.CompanyManageDetails,
          ],
        },
      ],
    },
  ],
};
